import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useAuth } from '../../AuthProvider';
import { baseUrl_SPB } from '../../BaseUrl';
import { MenuItem, Select } from '@mui/material';

const XeroEmployeeImport = (props) => {
    const [employees, setEmployees] = useState([]);
    const [saving, setSaving] = useState(false);
    const [message, setMessage] = useState('');
    const authContext = useAuth();
    const getXeroCredentials = () => {
        const xeroAccessToken = sessionStorage.getItem('xero_access_token');

        const tenantId = sessionStorage.getItem('tenant_id');
        return JSON.stringify({
            xeroAccessToken: xeroAccessToken,
            tenantId: tenantId // Assumes xeroAccessToken is defined
        })
    }
    useEffect(() => {
        const fetchXeroEmployees = async () => {
            try {
                const response = await fetch(`${baseUrl_SPB}/api/v1/xero/employee/import/list/${props.additionalUserInfo.companyId}`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + authContext.token, // Assumes authContext is defined and holds a token
                    },
                    body: getXeroCredentials()
                });
                const data = await response.json();

                setEmployees(data);
            } catch (error) {
                console.error('Error fetching employees:', error);
            }
        };

        fetchXeroEmployees();
    }, [props.additionalUserInfo.companyId]);

    const handleChange = (index, field, value) => {
        const updatedEmployees = [...employees];
        updatedEmployees[index][field] = value;
        setEmployees(updatedEmployees);
    };
    

    const handleAddEmployee = () => {
        setEmployees([
            ...employees,
            { firstName: '', lastName: '', email: '', xeroEmployeeId: '' }
        ]);
    };

    const handleRemoveEmployee = (indexToRemove) => {
        setEmployees(employees.filter((_, index) => index !== indexToRemove));
    };

    const handleSave = async () => {
        setSaving(true);
        setMessage('');

        // ✅ Filter out incomplete rows (must have name and email)
        const validEmployees = employees.filter(emp =>
            emp.firstName?.trim() && emp.lastName?.trim() && emp.email?.trim()
        );

        if (validEmployees.length === 0) {
            setMessage('No valid employees to save. Please fill out required fields.');
            setSaving(false);
            return;
        }
        console.log('Saving employees:', validEmployees);
        try {
            const response = await fetch(`${baseUrl_SPB}/api/v1/invite/inviteandsave/list`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + authContext.token, // Assumes authContext is defined and holds a token
                    },
                    body:  JSON.stringify(validEmployees)
                });
           
            setMessage('Employees saved successfully!');
        } catch (error) {
            console.error('Error saving employees:', error);
            setMessage('Failed to save employees.');
        } finally {
            setSaving(false);
        }
    };

    return (
        <div>
            <h2>Employee List</h2>
            {message && <p>{message}</p>}

            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead>
                    <tr>
                        <th style={styles.th}>First Name</th>
                        <th style={styles.th}>Last Name</th>
                        <th style={styles.th}>Email</th>
                        <th style={styles.th}>Xero Employee ID</th>
                        <th style={styles.th}>Role</th>
                        <th style={styles.th}>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {employees.map((employee, index) => (
                        <tr key={index}>
                            <td style={styles.td}>
                                <input
                                    type="text"
                                    value={employee.firstName}
                                    onChange={(e) => handleChange(index, 'firstName', e.target.value)}
                                    style={styles.input}
                                    placeholder="First Name"
                                />
                            </td>
                            <td style={styles.td}>
                                <input
                                    type="text"
                                    value={employee.lastName}
                                    onChange={(e) => handleChange(index, 'lastName', e.target.value)}
                                    style={styles.input}
                                    placeholder="Last Name"
                                />
                            </td>
                            <td style={styles.td}>
                                <input
                                    type="email"
                                    value={employee.email}
                                    onChange={(e) => handleChange(index, 'email', e.target.value)}
                                    style={styles.input}
                                    placeholder="Email"
                                />
                            </td>
                            <td style={styles.td}>
                                <input
                                    type="text"
                                    value={employee.xeroEmployeeId || ''}
                                    onChange={(e) => handleChange(index, 'xeroEmployeeId', e.target.value)}
                                    style={styles.input}
                                    placeholder="Xero Employee ID"
                                />
                            </td>
                            <td style={styles.td}>
                                <div>Select a role</div>
                                  <Select className='selectField'
                                    labelId="role-select-label"
                                    id="role-select"
                                    value={employee.role || ''}
                                    label="Role"
                                    onChange={(e) => handleChange(index, 'role', e.target.value)}
                                  >
                                    <MenuItem value={'ROLE_EMPLOYEE'}>Employee</MenuItem>
                                    <MenuItem value={'ROLE_MANAGER'}>Manager</MenuItem>
                                    <MenuItem value={'ROLE_CMANAGER'}>Company Manager</MenuItem>
                                    <MenuItem value={'ROLE_FMANAGER'}>Finance Manager</MenuItem>
                                  </Select>
                            </td>
                            <td style={styles.td}>
                                <button 
                                    onClick={() => handleRemoveEmployee(index)} 
                                    style={styles.removeButton}
                                    type="button"
                                >
                                    Remove
                                </button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>

            <button onClick={handleAddEmployee} style={styles.addButton}>
                + Add New Employee
            </button>

            <button
                onClick={handleSave}
                disabled={saving}
                style={styles.saveButton}
            >
                {saving ? 'Saving...' : 'Save All Changes'}
            </button>
        </div>
    );
};

const styles = {
    th: {
        border: '1px solid #ccc',
        padding: '8px',
        backgroundColor: '#f0f0f0',
        textAlign: 'left',
    },
    td: {
        border: '1px solid #ccc',
        padding: '8px',
    },
    input: {
        width: '100%',
        padding: '4px',
        boxSizing: 'border-box',
    },
    saveButton: {
        marginTop: '20px',
        padding: '10px 20px',
        fontSize: '16px',
        backgroundColor: '#4CAF50',
        color: 'white',
        border: 'none',
        cursor: 'pointer',
        marginLeft: '10px',
    },
    addButton: {
        marginTop: '20px',
        padding: '10px 20px',
        fontSize: '16px',
        backgroundColor: '#2196F3',
        color: 'white',
        border: 'none',
        cursor: 'pointer',
    },
    removeButton: {
        padding: '6px 12px',
        backgroundColor: '#f44336',
        color: 'white',
        border: 'none',
        borderRadius: '4px',
        cursor: 'pointer',
    }
};

export default XeroEmployeeImport;